<script setup lang="ts">
import { Moon, Sun } from 'lucide-vue-next'

const { isDark, updateAppearance } = useAppearance()
const mounted = ref(false)

const toggleTheme = () => {
  updateAppearance(isDark.value ? 'light' : 'dark')
}

onMounted(() => {
  mounted.value = true
})
</script>

<template>
  <button
    @click="toggleTheme"
    class="cursor-pointer group relative w-10 h-10 flex items-center justify-center rounded-full transition-colors hover:bg-white/10 dark:hover:bg-white/10"
    aria-label="Toggle theme"
  >
    <template v-if="mounted">
      <Sun
        v-if="isDark"
        class="h-5 w-5 text-white/60 transition-all group-hover:text-blu-600 dark:group-hover:text-blu-400 group-hover:[animation:spin_1s_linear_infinite]"
      />
      <Moon
        v-else
        class="h-5 w-5 text-slate-700/75 transition-all group-hover:text-blu-600 dark:group-hover:text-blu-400"
      />
    </template>
    <div v-else class="h-5 w-5" />
  </button>
</template>
